import { createComponentById, NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { HtmlId } from '../enum';
import { createIconTextBannerComponent } from '@vfde-brix/ws10/icon-text-banner';

export const mountIcontTextBanner = (id: HtmlId) => {
    createComponentById(createIconTextBannerComponent, id, NO_PATTERN_BUSINESS_LOGIC);
};
